<div class="lex-change-indicator__container">
  <xi-icon [icon]="icon" [color]="color" iconSize="small"></xi-icon>

  <span class="lex-change-indicator__text">{{ displayValue }}</span>
</div>
